import { ANSWER_DECISION_SOURCES } from '@oefy/core';
import { z } from 'zod';
import { timestampSchema } from './common';

export const answerDecisionSchema = z.object({
  id: z.uuid(),
  answer: z.string(),
  sameMeaning: z.boolean(),
  source: z.enum(ANSWER_DECISION_SOURCES),
  model: z.string().nullable(),
  decidedBy: z.string().nullable(),
  timesUsed: z.int().min(0),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const questionAnswerDecisionsSchema = z.object({
  decisions: z.array(answerDecisionSchema),
});

export const answerDecisionParamsSchema = z.object({ id: z.uuid(), decisionId: z.uuid() });

export const answerDecisionInputSchema = z.object({ sameMeaning: z.boolean() });

export type AnswerDecision = z.infer<typeof answerDecisionSchema>;
export type QuestionAnswerDecisions = z.infer<typeof questionAnswerDecisionsSchema>;
export type AnswerDecisionInput = z.infer<typeof answerDecisionInputSchema>;
